var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36411 8.57808L1.41436 13.5278L0.000145435 12.1136L4.94989 7.16387L0.000145912 2.21412L1.41436 0.79991L6.36411 5.74966L7.77832 7.16387L6.36411 8.57808Z",
    fill: "#A4AAB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftScroll);
export default __webpack_public_path__ + "static/media/left-scroll.e087d90d923136b68c7ad7a137beae8d.svg";
export { ForwardRef as ReactComponent };